<template>
  <div class="rr-grid__col" :class="classes"><slot></slot></div>
</template>

<script>
export default {
  name: 'Col',
  props: {
    /**
     * Размер колонки.<br>
     * Строка:<br>`'Number', 'stretch' или 'auto'`<br>
     * Объект:<br>`{ default: '12', md: '6', lg: 'stretch' }`
     */
    size: {
      type: [String, Object],
      validator(value) {
        if (!value) {
          return true;
        }
        if (typeof value === 'string') {
          return value.match(/(stretch|auto|\d+)/);
        }
        if (typeof value === 'object') {
          return !Object.keys(value).some((val) => !value[val].match(/(stretch|auto|\d+)/));
        }
        return false;
      },
    },
    /**
     * Вертикальное выравнивание
     */
    align: {
      type: String,
      validator: (value) => value.match(/(start|center|end)/),
    },
  },
  computed: {
    classes() {
      const classes = [];
      const sizes = [];

      if (this.size) {
        if (typeof this.size === 'string') {
          sizes.push(this.size);
        }
        if (typeof this.size === 'object') {
          Object.keys(this.size).forEach((val) => {
            const prefix = val === 'default' ? '' : `${val}-`;
            sizes.push(`${prefix}${this.size[val]}`);
          });
        }
      }

      const modifiers = [...sizes, this.align && `align-${this.align}`];

      modifiers.forEach((modifier) => {
        if (modifier) {
          classes.push(`rr-grid__col_${modifier}`);
        }
      });

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Col";
</style>
